<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.employee') }} > {{ $t('sidebar.create') }}
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <HrmEmployeeForm
        :isSubmitted="isSubmitted"
        :departments="departments"
        :positions="positions"
        :disabled="disabled"
        :form.sync="form"
        :showActionButtons="hasRoleEdit"
        @onSubmit="handleSubmit"
      />

      <BaseConfirmDiscardModal
        :show="confirmDiscardModal.show"
        @onCancel="handleDiscardCancleModal"
        @onConfirm="handleDiscardConfirmModal"
      />
    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { toISODateString } from '@/helpers'
import sidebarModule from './../../sidebarModule'
import discardFormMixin from '@/mixins/discardForm'
import userPermissionMixin from '@/mixins/userPermission'

export default {
  mixins: [discardFormMixin, userPermissionMixin],
  data () {
    return {
      loading: true,
      isSubmitted: false,
      disabled: false,
      form: null,
    }
  },

  computed: {
    ...mapState('hrm', {
      departments: 'departmentList',
      positions: 'positionList',
    }),
  },

  created () {
    this.fetchData()
  },

  beforeMount () {
    this.initPage({
      section: 'app',
      name: this.$t('app.hrm.title'),
      current: {
        app_name: 'hrm',
        app_id: 13,
        module_id: 1,
      },
    })
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 0,
      submenuAtIdx: 1,
    })
  },

  destroyed () {
    this.leavePage(this.$Progress, [])
  },

  methods: {
    ...mapActions('hrm', {
      getDepartmentList: 'getDepartmentList',
      getPositionList: 'getPositionList',
      createEmployee: 'createEmployee',
    }),
    async fetchData () {
      this.loading = true
      const params = { page: 1, limit: 100000 }
      await Promise.all([
        this.getDepartmentList(params),
        this.getPositionList(params),
      ])
      this.loading = false
      this.showFinish(this.$Progress)
    },
    async handleSubmit (form = {}) {
      const data = {
        'name': form.name,
        'gender': form.gender,
        'birthdate': toISODateString(form.birthdate),
        'department_id': form.departmentId,
        'position_id': form.positionId,
        'contacts': (() => {
          const items = []
          if (form.tel) {
            items.push({ platform: 'tel', source: form.tel })
          }
          if (form.email) {
            items.push({ platform: 'email', source: form.email })
          }
          return items
        })(),
        'address': form.address,
        'wage_amount': form.wageAmount,
        'wage_type': form.wageType,
        'start_working_date': toISODateString(form.startWorkingDate),
        'note': form.note,
        'tags': form.tags,
      }
      this.disabled = true
      this.isSubmitted = true
      const response = await this.createEmployee(data)
      if (response.success) {
        this.disabled = false
        this.isSubmitted = false
        this.notify(this.$vs, {
          text: this.$t('message.hasbeencreated', { msg: form.name }),
          color: 'success',
          icon: 'cloud',
        })
        this.$router.push({
          name: 'EmployeeList',
          query: {
            ignoreDiscardAlert: true,
          },
        })
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/hrm/employee/Create.vue